import { MaterialComponentCategory } from 'api';
import { MaterialSupportedComponentList } from 'features';
import {
  MaterialAutocomplete,
  MaterialColourAutocomplete,
  MaterialFormAutocomplete,
  MaterialGradeAutocomplete,
  TextField,
  useFormContext,
  useWatch,
} from 'form';
import { Divider, Stack, Typography } from 'ui';

import { BuyerMaterialSpecificationFormType } from '../../pages/schema';
import { DocumentSection } from '../DocumentSection/DocumentSection';
import { PackagingSpecificationList } from '../PackagingSpecificationList/PackagingSpecificationList';

export const BuyerMaterialSpecificationFormFields = () => {
  const form = useFormContext<BuyerMaterialSpecificationFormType>();
  const [material_id, material_colour_id] = useWatch({
    control: form.control,
    name: ['material_id', 'material_colour_id'],
  });

  return (
    <Stack spacing={3}>
      <Stack spacing={2}>
        <Typography variant="subtitle1" fontWeight="bold">
          Material specifications
        </Typography>
        <MaterialAutocomplete name="material_id" label="Material" required />
        <MaterialFormAutocomplete name="material_form_id" label="Material form" required />
        <MaterialColourAutocomplete name="material_colour_id" label="Material colour" />
        <MaterialGradeAutocomplete label="Material grade" name="material_grade_id" required />
      </Stack>
      <Divider />
      <MaterialSupportedComponentList
        materialId={material_id}
        materialColourId={material_colour_id}
        name="material_qualities"
        category={MaterialComponentCategory.MATERIAL_QUALITY}
      />
      <Divider />
      <PackagingSpecificationList />
      <Divider />
      <Stack spacing={2} marginBottom={2}>
        <Typography variant="subtitle1" fontWeight="bold">
          Supporting information
        </Typography>
        <TextField label="Notes" name="notes" multiline />
        <DocumentSection />
      </Stack>
    </Stack>
  );
};
